import React, { Component, Fragment } from 'react';

import { Column } from 'react-virtualized';

import defaultRowRenderer from 'components/shared/ReactVirtualizedTable/DefaultRowRenderer';
import ReactVirtualizedTable from 'components/shared/ReactVirtualizedTable';
import { assetStatus } from 'components/shared/MaintenanceStatuses';
import AssetTableStatusMenu from 'components/shared/AssetTableStatusMenu';

import Button from '@material-ui/core/Button';

class MaintenanceAssetsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      rowData: {},
    };
  }

  handleClick = (event, rowData) => {
    this.setState({ anchorEl: event.currentTarget, rowData: rowData });
  };

  handleClose = () => {
    this.setState({ anchorEl: null, rowData: {} });
  };

  changeAssetStatus = statusName => {
    let assetData = this.state.rowData;
    assetData['status'] = statusName;

    this.props.updateAsset(assetData, assetData.id).then(() => {
      this.props.getMaintenanceAssets();
      this.handleClose();
    });
  };

  goToTicket = (event, ticketID) => {
    // Because we have two onClick functions (one for the row, and one for
    // the row button), we want to prevent both from triggering
    if (event._dispatchListeners.length === 2) return;
    this.props.goToTicket(ticketID);
  };

  render() {
    return (
      <Fragment>
        <AssetTableStatusMenu
          anchorEl={this.state.anchorEl}
          handleClose={this.handleClose}
          changeStatus={this.changeAssetStatus}
          currentStatus={this.state.rowData.status}
        />

        <ReactVirtualizedTable
          data={this.props.data}
          rowRenderer={defaultRowRenderer}
          onRowClick={({ rowData, event }) => this.goToTicket(event, rowData.id)}
          grouped
        >
          <Column
            width={125}
            label="Status"
            dataKey="status"
            cellRenderer={({ cellData, rowData }) => (
              <Button
                aria-owns={this.state.anchorEl ? 'simple-menu' : null}
                aria-haspopup="true"
                onClick={event => this.handleClick(event, rowData)}
              >
                <span>{assetStatus(cellData)}</span>
              </Button>
            )}
          />
          <Column width={200} label="Location" dataKey="location" />
          <Column width={200} label="Name" dataKey="name" />
          <Column width={200} label="Make" dataKey="make" />
          <Column width={175} label="Model" dataKey="model" />
          <Column width={200} label="Category" dataKey="category" />
        </ReactVirtualizedTable>
      </Fragment>
    );
  }
}

export default MaintenanceAssetsTable;
